import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_152: DocMigration = {
  maxSchemaVersion: "0.0.152",
  description: "adjust corner board top offset",
  apply(json: any) {
    const { settings: allSettings } = json;

    // create a first settings set if it doesn't exist. Reference first settings set id.
    let firstSettingsSetId: string | undefined = undefined;
    for (const settingsSetId in json.settingsSets) {
      const settingsSet = json.settingsSets[settingsSetId];
      if (settingsSet.sortIndex !== 0) {
        continue;
      }
      firstSettingsSetId = settingsSet.id;
    }

    if (firstSettingsSetId === undefined) {
      const baseSettingsSetId = uid();
      if (!json.settingsSets) {
        (json.settingsSets as any) = {};
      }

      (json.settingsSets[baseSettingsSetId] as any) = {
        entityType: "SETTINGS_SET",
        name: "Base Settings Set",
        id: baseSettingsSetId,
        sortIndex: 0,
      };
      firstSettingsSetId = baseSettingsSetId;
    }

    // add exterior trim settings
    let firstSettingsSetExteriorTrimSettingsId: string | undefined = undefined;

    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId] as any;
      if ((settings.type as any) === "EXTERIOR_TRIM_SETTINGS") {
        if (firstSettingsSetId !== undefined && settings.parentId !== undefined) {
          if (settings.parentId === firstSettingsSetId) {
            firstSettingsSetExteriorTrimSettingsId = settingsId;
            (allSettings[settingsId] as any) = {
              ...settings,
              outsideCornerBoardTopAlignment: "BO_SOFFIT_LEGACY",
            };
          }
        }
      }
    }

    if (!firstSettingsSetExteriorTrimSettingsId) {
      const newSettingsId = uid();
      (allSettings[newSettingsId] as any) = {
        ...{
          type: "EXTERIOR_TRIM_SETTINGS",
          outsideCornerBoardTopAlignment: "BO_SOFFIT_LEGACY",
        },
        entityType: "SETTINGS",
        id: newSettingsId,
        parentId: firstSettingsSetId,
        sortIndex: 0,
      };
    }

    return json;
  },
};

export default migration_0_0_152;
